import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { PosloginService } from '../../../POSServices/Login/poslogin.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isloginfailed: boolean = false;
  isloginSuccess: any = true;
  PosSubscriptionId= new FormControl("", [Validators.required]);
  employeeid= new FormControl("", [Validators.required]);
  passcode = new FormControl("", [Validators.required]);
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private activatedRoute: ActivatedRoute,
    private service: PosloginService,
  ) 
  { 
   }

  ngOnInit() {
    // localStorage.removeItem('VirtualPOSToken');
  }
  login() {
    let form = { employeeid: "", passcode: "" ,possubscriptionId:""};
    form.employeeid = this.employeeid.value;
    form.passcode = this.passcode.value;
    form.possubscriptionId = this.PosSubscriptionId.value;
    let encodedcredentials = btoa(this.employeeid.value + ':Internal');

    this.isloginSuccess = this.service.posloginUser(form).subscribe(res => {
      if(res !=null)
      {
        this.router.navigate(['/pos/']);
      }
      // if (environment.clientsidelogflag == 0) {
      //   console.log("login service - promise response data:  ", res);
      // }
      // // 0401
      // if (res['Code'] == "0401") {
      //   this.isloginfailed = true;
      // }
      // else {
      //   localStorage.setItem("VirtualPOSToken", JSON.stringify(res));
      // }
      // this.router.navigate(["/home/welcomepayg"]);




    });
  }

}
